import React from 'react'

// 5→1 star horizontal bar breakdown.
//
// Props:
//   breakdown: array of { star: 1..5, count: number } in any order, OR null
//   total: total review count (used for percentages)
//
// If `breakdown` is empty/null and total === 0, renders null (no fake data).
//
// Display rule: always renders rows 5..1 even if a star value is missing
// from the input, with count = 0.

const RatingBreakdown = ({
    breakdown,
    total = 0,
    className = '',
}) => {
    const safeTotal = Math.max(0, Number(total) || 0)
    const hasData = Array.isArray(breakdown) && breakdown.length > 0 && safeTotal > 0

    if (!hasData) {
        return (
            <div className={`flex flex-col gap-2 ${className}`}>
                {[5, 4, 3, 2, 1].map(star => (
                    <div key={star} className='flex items-center gap-3'>
                        <span className='inline-flex w-8 shrink-0 text-xs font-semibold text-slate-600'>{star}★</span>
                        <div className='flex-1 h-2 rounded-pill bg-slate-100 overflow-hidden' />
                        <span className='inline-flex w-6 shrink-0 text-xs text-slate-400 justify-end'>0</span>
                    </div>
                ))}
                <p className='mt-1 text-[11px] text-slate-400'>Bölgü məlumatı mövcud deyil.</p>
            </div>
        )
    }

    const find = (star) => breakdown.find(r => Number(r?.star) === star)?.count || 0

    return (
        <div className={`flex flex-col gap-2 ${className}`}>
            {[5, 4, 3, 2, 1].map(star => {
                const count = find(star)
                const pct = safeTotal > 0 ? Math.round((count / safeTotal) * 100) : 0
                return (
                    <div key={star} className='flex items-center gap-3'>
                        <span className='inline-flex w-8 shrink-0 text-xs font-semibold text-slate-600'>
                            {star}★
                        </span>
                        <div className='flex-1 h-2 rounded-pill bg-slate-100 overflow-hidden'>
                            <div
                                className='h-full bg-warning-500 transition-all'
                                style={{ width: `${pct}%` }}
                                aria-label={`${star} ulduz: ${count} rəy`}
                            />
                        </div>
                        <span className='inline-flex w-9 shrink-0 text-xs text-slate-500 justify-end tabular-nums'>
                            {count}
                        </span>
                    </div>
                )
            })}
        </div>
    )
}

export default RatingBreakdown
